import FormattedMessage from 'I18n/components/FormattedMessage';
import UISelect from 'UIComponents/input/UISelect';
import { jsx as _jsx } from "react/jsx-runtime";
function SubscriptionFilter({
  className,
  ButtonContent,
  anchorType = 'auto',
  options,
  onChange,
  value,
  multi = false
}) {
  return /*#__PURE__*/_jsx(UISelect, {
    className: className,
    ButtonContent: ButtonContent,
    anchorType: anchorType,
    buttonUse: "transparent",
    cache: {
      cache: options
    },
    clearable: true,
    "data-test-id": "subscription-filter",
    options: options,
    menuWidth: 250,
    multi: multi,
    onChange: onChange,
    placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "messaging-publishing.filters.subscription"
    }),
    value: value
  });
}
export default SubscriptionFilter;